export const team = 'team';
export const club = 'club';
export const combined = 'combined';
export const none = 'none';
